import { memo } from 'react';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import { SideBySideData } from '../../../../../types';
import { PreviewCard } from './PreviewCard';
import { PreviewSectionHeader } from './PreviewSectionHeader';

const scrollToInput = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        element.focus();

        const originalTransition = element.style.transition;
        const originalBoxShadow = element.style.boxShadow;
        const originalBorder = element.style.borderColor;

        element.style.transition = 'all 0.5s ease';
        element.style.boxShadow = '0 0 0 4px rgba(7, 187, 122, 0.2)';
        element.style.borderColor = '#07BB7A';

        setTimeout(() => {
            element.style.boxShadow = originalBoxShadow;
            element.style.borderColor = originalBorder;
            setTimeout(() => {
                element.style.transition = originalTransition;
            }, 500);
        }, 2000);
    }
};

const handleKeyDown = (e: React.KeyboardEvent, id: string) => {
    if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        scrollToInput(id);
    }
};

interface LivePreviewProps {
    data: SideBySideData;
    showSectionTitle?: boolean;
    onSwap?: () => void;
    onInteract?: () => void;
    className?: string;
    interactive?: boolean;
    activeCard?: 1 | 2 | null;
}

export const LivePreview = memo(({
    data,
    showSectionTitle = true,
    onSwap,
    onInteract,
    className = '',
    interactive = true,
    activeCard = null
}: LivePreviewProps) => (
    <div className="live-preview-section">
        <div className={`live-preview-container ${className} ${!interactive ? 'non-interactive' : ''}`} onClick={interactive ? onInteract : undefined}>
            {showSectionTitle && <h3>LIVE PREVIEW</h3>}
            <PreviewSectionHeader
                title={data.sectionTitle}
                titleColor={data.sectionTitleColor}
                subtitle={data.sectionSubtitle}
                subtitleColor={data.sectionSubtitleColor}
                interactive={interactive}
                onClick={scrollToInput}
            />

            <div className="preview-cards-row">
                <div className="preview-card-wrapper">
                    <PreviewCard
                        card={data.card1}
                        cardIndex={0}
                        interactive={interactive}
                        isHighlighted={activeCard === 1}
                        isDimmed={activeCard !== null && activeCard !== 1}
                        onClick={scrollToInput}
                        onKeyDown={handleKeyDown}
                    />
                </div>

                {onSwap && (
                    <div className="preview-swap-container">
                        <button className="preview-swap-btn" onClick={(e) => { e.stopPropagation(); onSwap(); }} title="Swap Cards">
                            <SwapHorizIcon />
                        </button>
                    </div>
                )}

                <div className="preview-card-wrapper">
                    <PreviewCard
                        card={data.card2}
                        cardIndex={1}
                        interactive={interactive}
                        isHighlighted={activeCard === 2}
                        isDimmed={activeCard !== null && activeCard !== 2}
                        onClick={scrollToInput}
                        onKeyDown={handleKeyDown}
                    />
                </div>
            </div>
        </div>
    </div>
));

export { PreviewCard } from './PreviewCard';
export { PreviewSectionHeader } from './PreviewSectionHeader';
export { ArrowButtonHome } from './ArrowButtonHome';
